module.exports = __webpack_public_path__ + "img/fission.a5aa3aa5.png";